import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from "@material-ui/core/Button";
import {deleteAMessage, loadMessagesData, saveAMessage, updateAMessage} from "../../redux/modules/message";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//import {loadCamerasData} from "../../redux/modules/camera";
import {withStyles} from "@material-ui/core";
import DynamicTable from "./DynamicTable";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
//import {loadLocationsData} from "../../redux/modules/location";


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#e2580d",
        color:"black",
    },
});


class MessageForm extends React.Component {


    state = {

        //selectedLocation:{},
        selectedMessage:{},
        inputFieldShrinkState:true,
        numberShrink:false  //Jut sfor alter I can add a shrink flag for each filed. 

    };


    constructor(props) {
        super(props);
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.clearFields = this.clearFields.bind(this);
        this.refresh = this.refresh.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        
        
        this.handleSenderIdChange = this.handleSenderIdChange.bind(this);
        this.handleVehicleIdChange = this.handleVehicleIdChange.bind(this);
        this.handlegpsLongitudeChange = this.handlegpsLongitudeChange.bind(this);
        this.handlegpsLatitudeChange = this.handlegpsLatitudeChange.bind(this);

        this.handleMessageStateChange = this.handleMessageStateChange.bind(this);

        this.handleMessageTextChange = this.handleMessageTextChange.bind(this);
        this.handleMessagePictureChange = this.handleMessagePictureChange.bind(this);
        this.handleSenderGroupIdChange = this.handleSenderGroupIdChange.bind(this);
        this.handleCCTransactionIdChange = this.handleCCTransactionIdChange.bind(this);
        this.handleNotifierAddressChange = this.handleNotifierAddressChange.bind(this);
        this.handleVehicleLocationChange = this.handleVehicleLocationChange.bind(this);



    }



    /*

     private String id;
      private String senderid;
                      -private String vehicleid;
                      -private String gpsLatitude;
                      -private String gpsLongitude;
      private Date   messagetime;
                      -private String messagestate;
                      -private String messagetext;
                      -private String messagepicture;
                      -private String sendergroupid;
                      -private String cctransactionid;
                      -private String notifieraddress;
                       -private String vehiclelocation;

       */



    handleSubmit () {


        let { saveAMessage } = this.props;

        var tempStream = this.state.selectedMessage ;
        //tempStream.locationId= this.state.selectedLocation.id;
        saveAMessage(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };

    handleUpdate () {
        let { updateAMessage } = this.props;

        var tempStream = this.state.selectedMessage ;
        //tempStream.locationId= this.state.selectedLocation.id;
        updateAMessage(DEFAULT_VESPAAN_SERVER.url,  tempStream);

    };




    handleCCTransactionIdChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{cctransactionid:event.target.value}));
    }
    handleSenderGroupIdChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{sendergroupid:event.target.value}));
    }

    handleMessagePictureChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{messagepicture:event.target.value}));
    }


    handleMessageTextChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{messagetext:event.target.value}));
    }

    handleMessageStateChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{state:event.target.value}));
    }

    handlegpsLongitudeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{gpsLongitude:event.target.value}));
    }

    handleSenderIdChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{senderid:event.target.value}));
    }




    handlegpsLatitudeChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{gpsLatitude:event.target.value}));
    }

    handleVehicleIdChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{vehicleid:event.target.value}));
    }

    handleMessageRoutingChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{messageRoutingNumber:event.target.value}));
    }

    handleNotifierAddressChange(event) {
        //event.preventDefault();
        this.setState(Object.assign(this.state.selectedMessage,{notifieraddress:event.target.value}));
        this.setState({numberShrink:true});
    }

    handleVehicleLocationChange(event) {
        //event.preventDefault();
        //this.setState({selectedLocation: event.target.value});
        this.setState(Object.assign(this.state.selectedMessage,{vehiclelocation:event.target.value}));
        //this.setState({selectedVideoControllerName: event.target.value.displayName});
    }


    clearFields = (e) => {
        e.preventDefault();
        this.setState(state => ({
            inputFieldShrinkState:true
        }));


        var tempSelectedMessage =   Object.assign({}, this.state.selectedMessage);
        Object.keys(tempSelectedMessage).map((key, index) => {
            tempSelectedMessage[key] = "" ;
        });
        this.setState({selectedMessage:tempSelectedMessage})




    };
    renderErrorFiled(data){


    }

    refresh(event) {
        let { loadMessagesData } = this.props;
        loadMessagesData(DEFAULT_VESPAAN_SERVER.url );
    }


    render() {
        const {classes} = this.props;
        return (
        <React.Fragment>
        <Typography variant="h6" gutterBottom>
            Message Information
        </Typography>
    <Grid container spacing={24}>

        <Grid item xs={12} sm={12}>
            {/* < FormControl className = {classes.formControl}  required fullWidth >
                    < InputLabel htmlFor = "age-simple" > Location < /InputLabel>
                        < Select ref = {c => this.mySelect = c} value = {this.state.selectedLocation} onChange = {this.handleVehicleLocationChange}
                        inputProps = { { name: 'location', id : 'location', } } >
                        {this.props.locationsArray.map(n => (<MenuItem value= {n}   ref={n.id} inputProps = { { name: n.id , id :n.id  } } >{n.name}</MenuItem>))}

                        < /Select>
                < /FormControl>
                */}
            <Grid container >
                <Grid item xs={5} sm={5} >
                    <TextField required id="notifieraddress" name="notifieraddress"  label="notifieraddress"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState || this.state.numberShrink  }}  value={this.state.selectedMessage.notifieraddress} onChange={this.handleNotifierAddressChange}/>
                </Grid>
                <Grid item xs={2} sm={2} >
                </Grid>
                <Grid item xs={5} sm={5} >
                    <TextField required id="vehicleid" name="vehicleid"  label="vehicleid"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.vehicleid} onChange={this.handleVehicleIdChange}/>
                </Grid>
            </Grid>
        <Grid container >
        <Grid item xs={5} sm={5}>
            <TextField  required id="gpsLatitude" name="gpsLatitude" label="gpsLatitude"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.gpsLatitude} onChange={this.handlegpsLatitudeChange}  />
        </Grid>
        <Grid item xs={2} sm={2} >
            </Grid>

        {/*
            <Grid item xs={5} sm={5} >
            <TextField required id="messageRoutingNumber" name="messageRoutingNumber"  label="messageRoutingNumber"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.messageRoutingNumber} onChange={this.handleMessageRoutingChange}/>
            </Grid>

            */}
        </Grid>

                <Grid item xs={12}>
                    <TextField  required id="gpsLongitude" name="gpsLongitude" label="gpsLongitude"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.gpsLongitude} onChange={this.handlegpsLongitudeChange}  />
                </Grid>
                <Grid item xs={12}>
                    <TextField id="messagestate" name="messagestate" label="messagestate" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.messagestate} onChange={this.handleMessageStateChange} />
                </Grid>
                <Grid container >
                        <Grid item xs={5} sm={5} >
                            <TextField required id="messagetext" name="messagetext" label="messagetext" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.messagetext} onChange={this.handleMessageTextChange}/>
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>
                        <Grid item xs={5} sm={5} >
                            <TextField id="messagepicture" name="messagepicture" label="messagepicture" fullWidth InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.messagepicture} onChange={this.handleMessagePictureChange}/>
                        </Grid>
                        <Grid item xs={5} sm={5}>
                            <TextField  required  id="cctransactionid"  name="cctransactionid"  label="cctransactionid"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.cctransactionid} onChange={this.handleCCTransactionIdChange}  />
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>
                        <Grid item xs={5} sm={5}>
                            <TextField  required id="sendergroupid"  name="sendergroupid"  label="sendergroupid"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.sendergroupid} onChange={this.handleSenderGroupIdChange} />
                        </Grid>

                        <Grid item xs={5} sm={5}>
                            <TextField  required id="vehiclelocation"  name="vehiclelocation"  label="vehiclelocation"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.vehiclelocation} onChange={this.handleVehicleLocationChange} />
                        </Grid>
                        <Grid item xs={2} sm={2} >
                        </Grid>
                        <Grid item xs={5} sm={5}>
                        <TextField  required id="senderid"  name="senderid"  label="senderid"  fullWidth  InputLabelProps={{ shrink: this.state.inputFieldShrinkState }}  value={this.state.selectedMessage.senderid} onChange={this.handleSenderIdChange} />
                        </Grid>

                </Grid>

                <Grid container >

                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmit} className={classes.button}  >
                        Add Message
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.handleUpdate} className={classes.button}  >
                        Update Message
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.clearFields} className={classes.button}  >
                        Clear Fields
                    </Button>
                    </Grid>
                    <Grid item xs={3} sm={3}>
                        <Button variant="contained" color="primary" onClick={this.refresh} className={classes.button}  >
                        Refresh
                        </Button>
                    </Grid>
                </Grid>
                <Grid container >
                     {  this.props.errorCMsg && (
                        <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Error - Operation Failed" value= {" message = " + this.props.errorCMsg.message + " details = " + this.props.errorCMsg.details + " Time = " +  this.props.errorCMsg.timestamp}
                            className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                        </Grid>)
                    }
                    {  !this.props.errorCMsg && (
                    <Grid item xs={12}   >
                        <TextField error id="outlined-error" label="Great! - Operation Success" value= "Nothing here"
                        className={classes.textField} margin="normal"  variant="outlined" disabled={true}  multiline={true}/>
                    </Grid>)
                    }
                </Grid>
                </Grid>
                <Grid item xs={12} sm={12}>
                    <DynamicTable  data={this.props.messagesArray}  onEdit={this.editRecord}  onDelete={this.deleteRecord}> </DynamicTable>
                </Grid>

            </Grid>
        </React.Fragment>
    );
    }//end of render



    editRecord(singleRowData){
        this.setState({inputFieldShrinkState:true});
        this.setState({selectedMessage:singleRowData });
        //We need to change the seleted Location as well.
        //let tempLocation = this.props.locationsArray.find(x => x.locationId == singleRowData.locationId );

        //this.setState({selectedLocation:tempLocation });

    }


    deleteRecord(argProcessId){
        //alert('I am deleting ' + argCameraId);
        let { deleteAMessage } = this.props;
        deleteAMessage(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
    }


    componentWillMount(){
        let { loadMessagesData , loadLocationsData } = this.props;
        loadMessagesData(DEFAULT_VESPAAN_SERVER.url );
        //loadLocationsData("http://localhost:9065/" );

            this.setState({
                errorCMsg:{}
            });


    }

    componentWillReceiveProps(nextProps) {
        if (this.props.messagesArray !== nextProps.messagesArray) {
            this.setState({
                messagesArray: nextProps.messagesArray
            });
        }
    }



}//end of class

MessageForm.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        messagesArray: state.message.messagesArray,
        MessageDeleteResponse:state.message.deleteMessageResp,
        MessageSaveResponse:state.message.saveMessageResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        errorCMsg:state.message.errorCMsg,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadMessagesData:loadMessagesData,
        deleteAMessage:deleteAMessage,
        saveAMessage:saveAMessage,
        updateAMessage:updateAMessage,

    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MessageForm));
